/** @format */
import { MarketCode } from '@mpb-com/feather/enums';

import { marketsWithTotalsExcludingTax } from '../config/market';

export const hasTotalsExcludingTax = (market: MarketCode) =>
    marketsWithTotalsExcludingTax.includes(market);
